const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3536 4.64645L11 4.29289L10.2929 5L10.6464 5.35355L14.7922 9.49927H4H3.5V10.4993H4H14.7936L10.6464 14.6464L10.2929 15L11 15.7071L11.3536 15.3536L16.3536 10.3536C16.5488 10.1583 16.5488 9.84171 16.3536 9.64645L11.3536 4.64645Z"
      fill="currentColor"
    />
  </svg>
);

export { ArrowRight };
